var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlueCarretLeft = function SvgBlueCarretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.498 5.402 5.999.451A.3.3 0 0 1 6.5.674v9.902a.3.3 0 0 1-.5.223L.497 5.848a.3.3 0 0 1 0-.446Z",
    fill: "#5452F6"
  })));
};
export default SvgBlueCarretLeft;